import * as Ajax from '../ajax/Ajax';
import "../models/user/UserResultModel";
import "../models/profile/ProfileResultModel";
/**
 * 一覧を取得します。
 *
 * @param fn ファンクション
 */

export function Query(searchWord, narrowdownUserFlag, narrowdownUserIdList, startRow, pageSize, fn) {
  Ajax.Post("UserApi/Query", {
    searchWord: searchWord,
    narrowdownUserFlag: narrowdownUserFlag,
    narrowdownUserIdList: narrowdownUserIdList,
    startRow: startRow,
    pageSize: pageSize
  }, Ajax.ModelResult(fn));
}
/**
 * ユーザーを追加します。
 *
 * @param userName ユーザー名
 * @param userMailAddress メールアドレス
 * @param authorityId 権限
 * @param canSupport サポート可否
 * @param contractManagerFlag 契約管理者フラグ
 * @param fn ファンクション
 */

export function AddUser(name, userMailAddress, authorityId, canSupport, contractManagerFlag, fn) {
  Ajax.Post("UserApi/AddUser", {
    name: name,
    userMailAddress: userMailAddress,
    authorityId: authorityId,
    canSupport: canSupport,
    contractManagerFlag: contractManagerFlag
  }, Ajax.ModelResult(fn));
}
/**
 * ユーザーを更新します。
 *
 * @param userId ユーザーＩＤ
 * @param userName ユーザー名
 * @param userMailAddress メールアドレス
 * @param organizationId 組織ID
 * @param currentAuthorityId 現在の権限ID
 * @param authorityId 権限ID
 * @param canSupport サポート可否
 * @param contractManagerFlag 契約管理者フラグ
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function ModifyUser(id, name, userMailAddress, organizationId, currentAuthorityId, authorityId, canSupport, contractManagerFlag, updateDateTime, fn) {
  Ajax.Post("UserApi/ModifyUser", {
    id: id,
    name: name,
    userMailAddress: userMailAddress,
    organizationId: organizationId,
    currentAuthorityId: currentAuthorityId,
    authorityId: authorityId,
    canSupport: canSupport,
    contractManagerFlag: contractManagerFlag,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}
/**
 * ユーザーを削除します。
 *
 * @param userId ユーザーＩＤ
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function DeleteUser(id, updateDateTime, fn) {
  Ajax.Post("UserApi/DeleteUser", {
    id: id,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}
/**
 * ユーザーパスワードのリセットを要求します。
 *
 * @param userId ユーザーＩＤ
 * @param fn ファンクション
 */

export function RequestResetPassword(id, fn) {
  Ajax.Post("UserApi/RequestResetPassword", {
    id: id
  }, Ajax.ModelResult(fn));
}
/**
 * アバターの変換状態を取得します。
 *
 * @param id ユーザーＩＤ
 * @param avatarFileName アバターファイル名
 * @param updateDateTime 更新日時
 * @param fn 戻し先ファンクション
 */

export function GetAvatarConversionStatus(id, avatarFileName, fn) {
  Ajax.Post("UserApi/GetAvatarConversionStatus", {
    id: id,
    avatarFileName: avatarFileName
  }, Ajax.ModelResult(fn));
}
/**
 * サムネイルを取得します。
 *
 * @param id ユーザーＩＤ
 * @param thumbnailFileName サムネイルファイル名
 * @param updateDateTime 更新日時
 * @param fn 戻し先ファンクション
 */

export function GetThumbnail(id, thumbnailFileName, fn) {
  var data = new FormData();
  data.append("id", id.toString());
  data.append("thumbnailFileName", thumbnailFileName);
  Ajax.Download("UserApi/GetThumbnail", data, fn);
}
/**
 * サムネイルをアップロードします。
 *
 * @param id ユーザーＩＤ
 * @param thumbnail サムネイル
 * @param updateDateTime 更新日時
 * @param fn 戻し先ファンクション
 */

export function UploadThumbnail(id, thumbnail, updateDateTime, fn) {
  var data = new FormData();
  data.append("id", id.toString());
  data.append("thumbnail", thumbnail, thumbnail.name);
  data.append("updateDateTime", updateDateTime);
  Ajax.Upload("UserApi/UploadThumbnail", data, Ajax.ModelResult(fn));
}
/**
 * アバターを削除します。
 *
 * @param id ユーザーＩＤ
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function DeleteThumbnail(id, updateDateTime, fn) {
  Ajax.Post("UserApi/DeleteThumbnail", {
    id: id,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}
/**
 * アバターを作成します。
 *
 * @param id ユーザーＩＤ
 * @param downloadUrl ダウンロードURL
 * @param updateDateTime 更新日時
 * @param fn 戻し先ファンクション
 */

export function CreateAvatar(id, downloadUrl, updateDateTime, fn) {
  var data = new FormData();
  data.append("id", id.toString());
  data.append("downloadUrl", downloadUrl);
  data.append("updateDateTime", updateDateTime);
  Ajax.SilentUpload("UserApi/CreateAvatar", data, Ajax.ModelResult(fn));
}
/**
 * アバターをアップロードします。
 *
 * @param id ユーザーＩＤ
 * @param avator アバター
 * @param updateDateTime 更新日時
 * @param fn 戻し先ファンクション
 */

export function UploadAvatar(id, avator, updateDateTime, fn) {
  var data = new FormData();
  data.append("id", id.toString());
  data.append("avator", avator);
  data.append("updateDateTime", updateDateTime);
  Ajax.SilentUpload("UserApi/UploadAvatar", data, Ajax.ModelResult(fn));
}
/**
 * アバターを削除します。
 *
 * @param id ユーザーＩＤ
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function DeleteAvatar(id, updateDateTime, fn) {
  Ajax.Post("UserApi/DeleteAvatar", {
    id: id,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}